import { render } from "./CustomerDetailPlaceholderTab.vue?vue&type=template&id=e7b62c9a"
import script from "./CustomerDetailPlaceholderTab.vue?vue&type=script&lang=js"
export * from "./CustomerDetailPlaceholderTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__